var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('login-form',{on:{"forgotPassword":_vm.forgotPasswordPopup}}),_c('div',{staticClass:"news-slideshow-wrapper"},[_c('v-carousel',{attrs:{"height":"100%","cycle":"","show-arrows":false,"hide-delimiter-background":""}},[_c('v-carousel-item',{attrs:{"show-arrows":false}},[_c('v-sheet',{style:({
            backgroundImage: 'url(' + require('@/assets/slide1.jpg') + ')',
          }),attrs:{"height":"100%","tile":"","show-arrows":false}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }